<div class="container-fluid">
  <div class="row pt-4 pl-4" style="font-size: 22px !important;
  font-weight: 400;
  color: #424242;">
    <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;
      Manage Roles</h5>
  </div>
<div id="mainContent" class="container">
  <div class="row pt-3">
    <div class="col-md-10 offset-md-1">
      <button id="addRoleBtn" name="addRoleBtn" mat-raised-button class="btn-theme" style="float:right" matTooltip="Click to add assignment" matTooltipPosition="left"
    (click)="openModal(modalContent,'add')">
        <i class="fa fa-plus-square" aria-hidden="true"></i>&nbsp;&nbsp; Role
    </button>
    </div>
  </div>
  
  <div class="pt-2 pb-2">
    <div class="col-md-12">
      <table class="table table-bordered table-striped table-sm">
        <thead class="">
          <tr>
            <th scope="col">Sr.No.</th>
            <th scope="col">Name</th>
            <th scope="col">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let modalFormObj of modalFormObjList; index as i" id="role_{{i}}">
            <td scope="row">{{i+1}}</td>
            <td>{{modalFormObj.name}}</td>
            <td>
              <button id="editRoleBtn_{{i}}" name="editRoleBtn_{{i}}" class="btn btn-sm btn-outline-theme"  (click)="onEditClick(modalContent,modalFormObj)"
              matTooltip="Click to edit" matTooltipPosition="above">
                <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
              </button> &nbsp;&nbsp;
              <button id="deleteRoleBtn_{{i}}" name="deleteRoleBtn_{{i}" class="btn btn-sm btn-outline-danger" (click)="onDeleteClick(modalFormObj)"
              matTooltip="Click to delete" matTooltipPosition="above">
                <i class="fa fa-trash-o" aria-hidden="true"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
</div>

  <!-- Modal Template -->
  <ng-template #modalContent let-modal>
    <div class="modal-header bg-theme bg-theme-txt pt-2 pb-2">
      <h5 class="modal-title" id="modal-basic-title">Role</h5>
    </div>
    <div class="modal-body">

      <form [formGroup]="modalForm">
        <div class="row">
        <label class="col-sm-4">Name :</label>
        <div class="col-sm-8">
        <input id="name" name="name" type="text" class="form-control form-control-xs"
        formControlName="name" [class.is-invalid]="formErrors.name && formSubmitted" matTooltip="{{formErrors.name}}" matTooltipPosition="above" matTooltipClass="warn-tooltip">
        </div>
        </div>

      </form>
    </div>
    <div class="modal-footer" >
      <div class="row col-md-12">
          <div class="col-sm-6"></div>
          <div class="col-sm-3">
            <button id="closeRoleBtn" name="deleteRoleBtn" type="button" class="btn btn-sm btn-block btn-outline-secondary" (click)="modal.dismiss('Cross click')">Close</button>
          </div>
          <div class="col-sm-3">
            <button id="saveRoleBtn" name="saveRoleBtn" type="button" *ngIf="modalStatus=='add'" class="btn btn-sm btn-block btn-outline-theme" (click)="onSaveClick()">Save</button>
            <button id="updateRoleBtn" name="updateRoleBtn" type="button" *ngIf="modalStatus=='edit'" class="btn btn-sm btn-block btn-outline-theme" (click)="onUpdateClick()">Update</button>
          </div>
      </div>
  </div>
  </ng-template>
